export default __webpack_public_path__ + "static/media/png-transparent-form-others-angle-text-photography.1cf82aee.webp";